import mapboxgl from 'mapbox-gl'

export default class Marker {
  constructor (lat, lng) {
    this.lat = lat
    this.lng = lng
    this.id = `marker-${Date.now()}`
  }

  addTo(map) {
    const marker = new mapboxgl.Marker({
        draggable: true
      })
      .setLngLat([this.lng, this.lat])
      .setPopup(this.popup)
      .addTo(map)

    marker.on('dragstart', () => {
      const event = new CustomEvent(`${this.id}-moving`, { bubbles: true, detail: { id: this.id }})
      window.dispatchEvent(event)
    })

    // Adjust coordinates when dragged by user
    marker.on('dragend', () => {
      const lngLat = marker.getLngLat()
      this.lat = lngLat['lat']
      this.lng = lngLat['lng']
      const event = new CustomEvent(`${this.id}-moved`, { bubbles: true, detail: { id: this.id, lng: this.lng, lat: this.lat} })
      window.dispatchEvent(event)
    })

    return marker
  }

  get html () {
    return `
      <div class="p-2">
        <header class="flex justify-between px-2 border-b border-gray-200">
          <h4 class="text-2xl pb-2">Show travel time</h4>
        </header>
        <br />
        <div>
          <form action="#"
            data-controller="maps--isochrone"
            data-maps--isochrone-lat-value="${this.lat}"
            data-maps--isochrone-lng-value="${this.lng}"
            data-maps--isochrone-id-value="${this.id}">
          </form>
        </div>
      </div>
    `
  }

  get popup () {
    return new mapboxgl.Popup({ maxWidth: '31rem', className: 'mb-popup rounded-xl' })
      .setHTML(this.html)
  }
}
